import React from "react";
import { ActionProps } from "react-querybuilder";
import { IconButton } from "@nuorder/components";

export const CustomRemoveRuleAction: React.FC<ActionProps> = ({ handleOnClick, ...props }) => {
    const handleClick = React.useCallback(
        (event) => {
            handleOnClick(event);
        },
        [handleOnClick]
    );

    return <IconButton {...props} onClick={handleClick} iconProps={{ iconName: "close24" }}></IconButton>;
};
